
import WidgetStepPreview from '@/libs/widget-step-preview.common.js'
import '@/libs/widget-step-preview.css'
import {i18nPages} from '@/i18n.config.js'

export default {
  name: "TemplateModal",
  props: {
    template: {
      type: Object,
      required: true,
    },
    totalTemplates: {
      type: Number,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: true,
    },
  },
  components: {
    WidgetStepPreview,
  },
  data() {
    return {
      targetImgIndex: 0, // now corresponds to the step index in the new data format
      i18nPages,
    };
  },
  filters: {
    snakeToTitleCase(value) {
      if (!value) return "";
      return value
        .split("-")
        .map((item) => item.charAt(0).toUpperCase() + item.substring(1))
        .join(" ");
    },
  },
  methods: {
    setTargetImage(index) {
      if (this.template.steps && index >= 0 && index < this.template.steps.length) {
        this.targetImgIndex = index;
      }
    },
    changeTemplate(newIndex) {
      if (newIndex >= 0 && newIndex < this.totalTemplates) {
        this.$emit("template-change", newIndex);
      } else {
        console.warn(`Template index out of bounds: ${newIndex}`);
      }
    },
  }
};
